
export default propertiesArrayBag => {
    if (!propertiesArrayBag) return null;
    const flattenedObj = {};
    propertiesArrayBag.forEach(kvObject => {
        flattenedObj[kvObject.key] = kvObject.value;
    });
    return flattenedObj;
};
